import { hgetRequest, hpostRequest } from '../../util/htools.axios';

/*
 *@Description: 管理员用户列表
 *@ClassAuthor: myw
 *@Date: 2021-05-13 17:23:34
*/
export const adminUserListService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				...data
			};
			const res = await hpostRequest('hlxpeng/user/systemUserAllQuery', dataJson);
			res.records.forEach(item => {
				item.roleIdsList = [];
				item.roleNamesList = [];
				// eslint-disable-next-line no-unused-expressions
				item.roleList?.forEach(role => {
					// const Role = JSON.parse(role);
					item.roleIdsList.push(role.id);
					item.roleNamesList.push(role.roleName);
				});
			});
			resolve(res);
		} catch (error) {
			console.log(error);
		}
	});
};
/*
 *@Description: 用户添加
 *@MethodAuthor:  zxh
 *@Date: 2020-12-04 11:36:10
 */
export const adminUserAddService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				...data
			};
			const res = await hpostRequest('hlxpeng/user/systemUserAdd', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
		}
	});
};
/*
 *@Description: 用户编辑
 *@MethodAuthor:  zxh
 *@Date: 2020-12-04 14:01:46
 */
export const adminUserEditService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				...data
			};
			if (dataJson.organizationId === 0) {
				dataJson.organizationId = null;
			} else {
				dataJson.organizationId = data.organizationId;
			}
			const res = await hpostRequest('hlxpeng/user/systemUserInfoUpdate', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
		}
	});
};
/*
 *@Description: 用户删除
 *@MethodAuthor:  zxh
 *@Date: 2020-12-04 14:40:48
 */
export const adminUserDeleteService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				...data
			};
			const res = await hpostRequest('hlxpeng/user/systemUserDel', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
		}
	});
};
/*
 *@Description: 根据登录用户查询当前登录人
 *@ClassAuthor: Happy ZXM
 *@Date: 2021-01-07 16:11:56
 */
export const adminUserLoginDetailService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				...data
			};
			const res = await hgetRequest('hlxpeng/user/listUserAll', dataJson);
			/* hsetStorage('organization', res.organization); */
			resolve(res);
		} catch (error) {
			console.log(error);
		}
	});
};
/*
 *@Description: 根据用户id查询用户详情
 *@MethodAuthor:  myw
 *@Date: 2020-12-08 10:36:27
 */
export const adminUserDetailService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				...data
			};
			const res = await hgetRequest('hlxpeng/user/systemUserByIdQuery', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
		}
	});
};
/*
 *@Description: 用户菜单权限
 *@MethodAuthor:  myw
 *@Date: 2020-12-08 11:42:03
 */
export const adminUserMenuAuthorizeService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				...data
			};
			const res = await hgetRequest('hlxpeng/user/systemUserByIdJurisdictionQuery', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
		}
	});
};
/*
 *@Description: 用户绑定角色
 *@MethodAuthor:  myw
 *@Date: 2020-12-10 17:11:00
 */
export const adminUserRoleService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				roleList: '',
				id: 0,
				...data
			};
			const res = await hpostRequest('hlxpeng/user/systemUserRoleBind', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
		}
	});
};
/*
 *@Description: 修改用户密码
 *@MethodAuthor:  myw
 *@Date: 2020-12-11 13:48:35
 */
export const adminUserPasswordEditService = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				userId: 0,
				userPwdNew: '',
				userPwdOld: '',
				...data
			};
			const res = await hpostRequest('hlxpeng/user/systemUserPassUpdate', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
		}
	});
};
export const adminUserPasswordEditService1 = data => {
	return new Promise(async resolve => {
		try {
			const dataJson = {
				userPwdNew: '',
				userPwdOld: '',
				...data
			};
			const res = await hpostRequest('hlxpeng/user/systemUserPassUpdate', dataJson);
			resolve(res);
		} catch (error) {
			console.log(error);
		}
	});
};

export default adminUserListService;
